export default __webpack_public_path__ + "Assets/FAMILY_BONUS/nordwest/Ablauf_Beantragung_Online-Zugang.pdf";